module.exports = __webpack_public_path__ + "static/media/2019_4G8A5798.790640ab.jpg";